import {Frontend} from "./frontend";

(function () {
    XonBoard.HKDualPressureSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function (asset_config, fresh) {
                if (fresh) {
                    this.selectors.sensor_reads_table = $('#sensor-reads-table');
                    this.selectors.count_label = $('#count-label');
                }

                let self = this;

                let columns = [
                    {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                    {data: 'status', name: 'sensor_reads.values->status', createdCell: self.renderCell,},
                ];

                for (let index in (asset_config['tanks'] || [])) {
                    let cols = [
                        {
                            data: 'tank_' + index + '_diesel_deep_cm',
                            name: 'sensor_reads.values->tank_' + index + '_diesel_deep_cm',
                            createdCell: this.renderCell,
                        },
                        asset_config['tanks'][index]['diesel_deep_cm_offset'] ? {
                            data: 'tank_' + index + '_diesel_deep_cm_with_offset',
                            name: 'sensor_reads.values->tank_' + index + '_diesel_deep_cm_with_offset',
                            createdCell: this.renderCell,
                        } : null,
                        {
                            data: 'tank_' + index + '_fuel_level',
                            name: 'sensor_reads.values->tank_' + index + '_fuel_level',
                            createdCell: this.renderCell,
                        },
                        {
                            data: 'tank_' + index + '_consumption',
                            name: 'sensor_reads.values->tank_' + index + '_consumption',
                            createdCell: this.renderCell,
                        },
                        {
                            data: 'tank_' + index + '_to_fill',
                            name: 'sensor_reads.values->tank_' + index + '_to_fill',
                            createdCell: this.renderCell,
                        },
                        {
                            data: 'tank_' + index + '_pressure_kpa',
                            name: 'sensor_reads.values->tank_' + index + '_pressure_kpa',
                            createdCell: this.renderCell,
                        },
                    ];

                    columns = columns.concat(cols.filter((item) => item));
                }

                columns.push(
                    {
                        data: 'actions',
                        name: 'actions',
                        searchable: false,
                        sortable: false,
                        createdCell: this.renderCell,
                    }
                );

                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if (cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
